import { TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import { editDeeplink } from 'src/store/modules/imageUpload';

interface editTextProps {
  menuTitle: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0 0.78rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    height: '100px',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'overlay',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

const EditMultiDeeplink: FC<editTextProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  var currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  var deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  // let newDeeplink = deeplink?.[type]?.slice();
  // newDeeplink?.splice(currentIndex, 1, e.target.value);
  // dispatch(editDeeplink({ ...deeplink, ...newDeeplink }));

  const handleText = e => {
    // const textSplit = e.target.value.split('');
    // if (
    //   textSplit[textSplit.length - 1] === '\\' ||
    //   // textSplit[textSplit.length - 1] === '"' ||
    //   // textSplit[textSplit.length - 1] === "'" ||
    // textSplit[textSplit.length - 1] === '\n'
    // ) {
    //   return;
    // }

    e.target.value = e.target.value.replace(/"/g, "'").replace(/\n/g, '');

    let newDeeplinks = deeplink?.[type]?.slice();

    newDeeplinks.splice(currentIndex, 1, e.target.value);

    // const newDeeplink = JSON.parse(
    //   `{"${type}": [${newDeeplinks?.map((_: any, idx: number) => {
    //     const newD = newDeeplinks?.[idx];
    //     return `"${newD}"`;
    //   })}]}`
    // );

    // dispatch(editDeeplink({ ...deeplink, ...newDeeplink }));

    const newDeeplink = {
      [type]: newDeeplinks?.map((_: any, idx: number) => {
        const newD = newDeeplinks?.[idx];
        return `${newD}`;
      })
    };
    dispatch(editDeeplink({ ...deeplink, ...newDeeplink }));
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem'
        }}
      >
        DEEPLINK
        {/* {menuTitle} */}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        }}
      >
        {/* <div className={classes.container}> */}
        {/* <Input
          className={classes.input}
          multiline={true}
          value={text?.[type]?.[currentIndex]}
          onChange={handleText}
          disableUnderline
        /> */}
        <TextField
          className={classes.input}
          id="standard-multiline-flexible"
          multiline
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.inputText
            },
            disableUnderline: true
          }}
          value={deeplink?.[type]?.[currentIndex]}
          onChange={handleText}
          // onKeyPress={handleKey}
        />
        {/* </div> */}
      </div>
    </div>
  );
};

export default EditMultiDeeplink;
